import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { RestaurantMap } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useRestaurantMapsWithTables = () => {
  const branch = useBranchId();
  return useQuery<RestaurantMap[]>({
    queryKey: ["restaurantMapWithTables", branch],
    queryFn: () =>
      get2(`/internal/secure/pos/v1/restaurant/map/with/tables/${branch}`),
  });
};

export default useRestaurantMapsWithTables;
